<template>
    <v-container class="overflow-auto pa-5 ma-0" style="max-width: 900px">
        <v-form ref="form" @input="$emit('input', $event)">
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <h4>{{ $t('contactperson') }}</h4>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- sex -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('anrede')">
                        <v-radio-group
                            dense
                            hide-details="auto"
                            :value="record.con_sex"
                            row
                            @change="onInput('con_sex', $event)"
                        >
                            <v-radio :label="$t('frau')" value="f" />
                            <v-radio :label="$t('herr')" value="m" />
                            <v-radio :label="$t('divers')" value="d" />
                        </v-radio-group>
                    </LabelField>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- firstname -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('vorname')">
                        <v-text-field
                            hide-details="auto"
                            :value="record?.con_firstname"
                            counter="50"
                            :rules="[getRule('maxLength')(50)]"
                            dense
                            outlined
                            @input="onInput('con_firstname', $event)"
                        />
                    </LabelField>
                </v-col>
                <!-- lastname -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('name')">
                        <v-text-field
                            hide-details="auto"
                            :value="record?.con_lastname"
                            counter="50"
                            :rules="[getRule('maxLength')(50)]"
                            dense
                            outlined
                            @input="onInput('con_lastname', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>

            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <h4>{{ $t('adresse') }}</h4>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- street -->
                <v-col cols="12" lg="4" xl="5" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('strasse')">
                        <v-text-field
                            :value="record?.con_street"
                            dense
                            outlined
                            counter="100"
                            :rules="[getRule('maxLength')(100)]"
                            hide-details="auto"
                            @input="onInput('con_street', $event)"
                        />
                    </LabelField>
                </v-col>
                <!-- street_nr -->
                <v-col cols="12" lg="2" xl="1" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('strasse_nr')">
                        <v-text-field
                            :value="record?.con_street_nr"
                            dense
                            outlined
                            hide-details="auto"
                            counter="15"
                            :rules="[getRule('maxLength')(15)]"
                            @input="onInput('con_street_nr', $event)"
                        />
                    </LabelField>
                </v-col>
                <!-- plz (zip) -->
                <v-col cols="12" lg="2" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('plz')">
                        <v-text-field
                            :value="record?.con_zip"
                            dense
                            outlined
                            hide-details="auto"
                            counter="10"
                            :rules="[getRule('between')(1000, 99999)]"
                            @input="onInput('con_zip', $event)"
                        />
                    </LabelField>
                </v-col>
                <!-- city -->
                <v-col cols="12" lg="4" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('ort')">
                        <v-text-field
                            :value="record?.con_city"
                            dense
                            outlined
                            hide-details="auto"
                            counter="100"
                            :rules="[getRule('maxLength')(100)]"
                            @input="onInput('con_city', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- address_supplement -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('adresszusatz')">
                        <v-text-field
                            :value="record?.con_address_supplement"
                            dense
                            outlined
                            hide-details="auto"
                            counter="100"
                            :rules="[getRule('maxLength')(100)]"
                            @input="onInput('con_address_supplement', $event)"
                        />
                    </LabelField>
                </v-col>
                <!-- po_box -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('postfach')">
                        <v-text-field
                            :value="record?.con_po_box"
                            dense
                            outlined
                            hide-details="auto"
                            counter="100"
                            :rules="[getRule('maxLength')(100)]"
                            @input="onInput('con_po_box', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- country_id -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('land')">
                        <CountrySelectField
                            :value="record?.con_country_id"
                            hide-details="auto"
                            item-value="id"
                            :label="null"
                            @input="onInput('con_country_id', $event)"
                        />
                    </LabelField>
                </v-col>
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }"></v-col>
            </v-row>

            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-4"
            >
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <h4>{{ $t('contact') }}</h4>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- tel -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('tel')">
                        <v-text-field
                            :value="record?.con_tel"
                            dense
                            outlined
                            hide-details="auto"
                            counter="50"
                            :rules="[getRule('maxLength')(50)]"
                            @input="onInput('con_tel', $event)"
                        />
                    </LabelField>
                </v-col>
                <!-- mobile -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('tel_2')">
                        <v-text-field
                            :value="record?.con_mobile"
                            dense
                            outlined
                            hide-details="auto"
                            counter="50"
                            :rules="[getRule('maxLength')(50)]"
                            @input="onInput('con_mobile', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- mail -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('email')">
                        <v-text-field
                            :value="record?.con_email"
                            dense
                            outlined
                            hide-details="auto"
                            counter="256"
                            :rules="[getRule('email'), getRule('maxLength')(256)]"
                            @input="onInput('con_email', $event)"
                        >
                            <template #append>
                                <a :href="`mailto:${record.email}`">
                                    <KpIcon icon-cls="link" color="primary" disabled-color="grey" />
                                </a>
                            </template>
                        </v-text-field>
                    </LabelField>
                </v-col>
                <!-- web -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('webseite')">
                        <UrlField
                            :value="record?.con_web"
                            counter="256"
                            :rules="[getRule('maxLength')(256)]"
                            @input="onInput('con_web', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- con_function -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('func_info')">
                        <v-text-field
                            hide-details="auto"
                            :value="record?.con_function"
                            :rules="[getRule('required')]"
                            dense
                            outlined
                            @input="onInput('con_function', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import { RequestedUser } from '@/models/RequestedUser';
import CountrySelectField from '@/components/country/SelectField.vue';
import getRulesMixin from '@/mixins/get-form-rules';

export default {
    name: 'RequestedUserContactData',
    components: {
        CountrySelectField,
    },
    mixins: [getRulesMixin],

    props: {
        record: {
            type: RequestedUser,
            required: true,
        },
    },

    mounted() {
        this.validateForm();
    },

    methods: {
        validateForm() {
            this.$refs.form.validate();
        },

        onInput(field, value) {
            this.record?.set(field, value);
        },
    },
};
</script>

<style lang="scss" scoped></style>
